import {Component, OnInit} from '@angular/core';
import {QuotationService} from '../../services/quotation-service/quotation.service';
import {InsureStep} from '../insureStep';
import {Router} from '@angular/router';
import {QuotationType} from '../../model/QuotationType';
import {WebLeadType} from '../../model/leads/WebLeadType';
import {LeadService} from '../../services/lead-service/lead.service';
import {QuickQuote} from '../../model/quotes/QuickQuote';
import {InsureFragment} from "../../model/InsureFragment";
import {GoogleAnalyticsService} from "google-analytics";

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent extends InsureStep implements OnInit {
  public quotationType = QuotationType;
  public testCollapse = [true, true, true];
  fragment: string;

  constructor(router: Router, public quotationService: QuotationService,
              private leadService: LeadService,
              private googleAnalyticsService: GoogleAnalyticsService,) {
    super(router, quotationService);

    if (this.quotationService.getRetries() === 0) {
      this.quotationService.error = true;
    }
  }

  callMeBack(quote: any) {
    if (quote == null) {
      return;
    }

    // Send GA the lead reference
    if (this.leadService.createLeadResponse && this.leadService.createLeadResponse.leadReferenceNumber) {
      this.googleAnalyticsService.postGaEvent(
        'form_step_complete',
        {
          'form_name': 'insure_quote_tool',
          'form_action': 'call_me_back',
          'form_step': 4,
          'lead_id': this.leadService.createLeadResponse.leadReferenceNumber.valueOf()
        }
      );
    }
    if(localStorage.getItem('urlHasLeadReference') === 'true'){
      this.googleAnalyticsService.postGaEvent(
        'form_step_complete',
        {
          'form_name': 'insure_quote_tool',
          'form_action': 'call_me_back',
          'form_step': 4,
          'lead_id': +localStorage.getItem('leadReferenceNumbers').valueOf()
        }
      );
    }

    const leadUpdate = this.leadService.updateLead(WebLeadType.WEB_LEAD_1, null, quote.quoteNo,
      null, this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium);
    if (leadUpdate) {
      leadUpdate.subscribe(
        response => {
          this.leadService.updateLeadResponse = response;

        }, error => {
          this.quotationService.error = true;
        });
    }
    this.router.navigateByUrl('thank-you');
  }

  ngOnInit() {
    this.getFragment();
    this.getRecommendation();

    for (const quote of this.quotationService.quotationsForClient.quickQuote) {
      if (quote.quoteStatus.toLowerCase() === 'indicative' || quote.quoteStatus.toLowerCase() === 'invalid') {
        this.quotationService.isIndicativeOrInvalid = true;
        this.router.navigateByUrl('thank-you');
      }
    }
  }

  isRecommended(quote: QuickQuote) {
    if (this.quotationService.quotationType === QuotationType.CAR_AND_HOME) {
      if (quote.quoteType === QuotationType.CAR_AND_HOME) {
        return true;
      }
    } else {
      if (quote.planType === 'CLASSIC_PLAN' && quote.quoteType !== QuotationType.CAR_AND_HOME) {
        return true;
      }
    }
  }

  toggleCollapse(index) {
    this.testCollapse[index] = !this.testCollapse[index];
  }

  getFragment() {
    this.leadService.getCrossSellProductFragment().subscribe((response: InsureFragment) => {
      if (response) {
        this.fragment = response.fragment;
        this.leadService.fragment = this.fragment;
      }
    });
  }

  getRecommendation() {
    const crossSellRecommendation = this.leadService.getCrossSellRecommendation();

    crossSellRecommendation.subscribe(value => {
      this.leadService.crossSellRecommendation = value;
    });
  }
}
